export const QUESTIONS_GPLX_CODE = [

    {
        "id": "chapter1",
        "name": "Quy định chung",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128,
            129,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            139,
            140,
            141,
            142,
            143,
            144,
            145,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            155,
            156,
            157,
            158,
            159,
            160,
            161,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            171,
            172,
            173,
            174,
            175,
            176,
            177,
            178,
            179,
            180
        ]
    },
    {
        "id": "chapter1",
        "name": "Quy định chung",
        "codes": [
            "A1_A"
        ],
        "questions": [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            19,
            20,
            21,
            22,
            24,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            51,
            52,
            53,
            54,
            56,
            57,
            59,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            80,
            81,
            87,
            88,
            90,
            91,
            92,
            93,
            94,
            96,
            97,
            98,
            99,
            100,
            102,
            103,
            107,
            109,
            110,
            111,
            119,
            123,
            124,
            125,
            126,
            137,
            138,
            140,
            141,
            142,
            145,
            146,
            151,
            155,
            163,
            167,
            178
        ]
    },
    {
        "id": "chapter1",
        "name": "Quy định chung",
        "codes": [
            "B1"
        ],
        "questions": [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            19,
            20,
            21,
            22,
            24,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            59,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            80,
            81,
            82,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            96,
            97,
            98,
            99,
            100,
            102,
            103,
            107,
            108,
            109,
            110,
            111,
            119,
            123,
            124,
            125,
            126,
            137,
            138,
            139,
            140,
            141,
            142,
            145,
            146,
            151,
            155,
            157,
            162,
            163,
            165,
            166,
            167,
            178
        ]
    },
    {
        "id": "chapter2",
        "name": "Văn hóa giao thông",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            181,
            182,
            183,
            184,
            185,
            186,
            187,
            188,
            189,
            190,
            191,
            192,
            193,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            203,
            204,
            205
        ]
    },
    {
        "id": "chapter2",
        "name": "Văn hóa giao thông",
        "codes": [
            "A1_A"
        ],
        "questions": [
            182,
            185,
            187,
            189,
            191,
            192,
            193,
            194,
            195,
            200
        ]
    },
    {
        "id": "chapter2",
        "name": "Văn hóa giao thông",
        "codes": [
            "B1"
        ],
        "questions": [
            82,
            185,
            187,
            189,
            191,
            192,
            193,
            194,
            195,
            200
        ]
    },
    {
        "id": "chapter3",
        "name": "Kỹ thuật lái xe",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            206,
            207,
            208,
            209,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            219,
            220,
            221,
            222,
            223,
            224,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            235,
            236,
            237,
            238,
            239,
            240,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250,
            251,
            252,
            253,
            254,
            255,
            256,
            257,
            258,
            259,
            260,
            261,
            262,
            263
        ]
    },
    {
        "id": "chapter3",
        "name": "Kỹ thuật lái xe",
        "codes": [
            "A1_A"
        ],
        "questions": [
            206,
            215,
            219,
            232,
            233,
            240,
            241,
            242,
            254,
            255,
            257,
            258,
            259,
            260,
            261
        ]
    },
    {
        "id": "chapter3",
        "name": "Kỹ thuật lái xe",
        "codes": [
            "B1"
        ],
        "questions": [
            206,
            215,
            219,
            232,
            233,
            240,
            241,
            242,
            254,
            255,
            257,
            258,
            259,
            260,
            261
        ]
    },
    {
        "id": "chapter4",
        "name": "Cấu tạo và sửa chữa",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            264,
            265,
            266,
            267,
            268,
            269,
            270,
            271,
            272,
            273,
            274,
            275,
            276,
            277,
            278,
            279,
            280,
            281,
            282,
            283,
            284,
            285,
            286,
            287,
            288,
            289,
            290,
            291,
            292,
            293,
            294,
            295,
            296,
            297,
            298,
            299,
            300
        ]
    },
    {
        "id": "chapter4",
        "name": "Cấu tạo và sửa chữa",
        "codes": [
            "A1_A"
        ],
        "questions": []
    },
    {
        "id": "chapter4",
        "name": "Cấu tạo và sửa chữa",
        "codes": [
            "B1"
        ],
        "questions": [
            266,
            285
        ]
    },
    {
        "id": "chapter5",
        "name": "Biển báo",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            301,
            302,
            303,
            304,
            305,
            306,
            307,
            308,
            309,
            310,
            311,
            312,
            313,
            314,
            315,
            316,
            317,
            318,
            319,
            320,
            321,
            322,
            323,
            324,
            325,
            326,
            327,
            328,
            329,
            330,
            331,
            332,
            333,
            334,
            335,
            336,
            337,
            338,
            339,
            340,
            341,
            342,
            343,
            344,
            345,
            346,
            347,
            348,
            349,
            350,
            351,
            352,
            353,
            354,
            355,
            356,
            357,
            358,
            359,
            360,
            361,
            362,
            363,
            364,
            365,
            366,
            367,
            368,
            369,
            370,
            371,
            372,
            373,
            374,
            375,
            376,
            377,
            378,
            379,
            380,
            381,
            382,
            383,
            384,
            385,
            386,
            387,
            388,
            389,
            390,
            391,
            392,
            393,
            394,
            395,
            396,
            397,
            398,
            399,
            400,
            401,
            402,
            403,
            404,
            405,
            406,
            407,
            408,
            409,
            410,
            411,
            412,
            413,
            414,
            415,
            416,
            417,
            418,
            419,
            420,
            421,
            422,
            423,
            424,
            425,
            426,
            427,
            428,
            429,
            430,
            431,
            432,
            433,
            434,
            435,
            436,
            437,
            438,
            439,
            440,
            441,
            442,
            443,
            444,
            445,
            446,
            447,
            448,
            449,
            450,
            451,
            452,
            453,
            454,
            455,
            456,
            457,
            458,
            459,
            460,
            461,
            462,
            463,
            464,
            465,
            466,
            467,
            468,
            469,
            470,
            471,
            472,
            473,
            474,
            475,
            476,
            477,
            478,
            479,
            480,
            481,
            482,
            483,
            484,
            485
        ]
    },
    {
        "id": "chapter5",
        "name": "Biển báo",
        "codes": [
            "A1_A"
        ],
        "questions": [
            303,
            304,
            305,
            306,
            307,
            313,
            314,
            315,
            317,
            318,
            322,
            323,
            324,
            325,
            326,
            329,
            330,
            335,
            345,
            346,
            347,
            348,
            349,
            350,
            351,
            354,
            360,
            362,
            364,
            366,
            367,
            368,
            369,
            370,
            371,
            372,
            373,
            374,
            375,
            376,
            377,
            380,
            381,
            382,
            386,
            387,
            389,
            390,
            391,
            393,
            394,
            395,
            397,
            398,
            400,
            401,
            411,
            412,
            413,
            415,
            419,
            422,
            427,
            430,
            431,
            432,
            433,
            434,
            435,
            437,
            438,
            439,
            440,
            441,
            442,
            445,
            450,
            451,
            452,
            454,
            455,
            457,
            458,
            459,
            460,
            461,
            474,
            475,
            476,
            478
        ]
    },
    {
        "id": "chapter5",
        "name": "Biển báo",
        "codes": [
            "B1"
        ],
        "questions": [
            303,
            304,
            305,
            306,
            307,
            313,
            314,
            315,
            317,
            318,
            322,
            323,
            324,
            325,
            326,
            329,
            330,
            332,
            333,
            334,
            335,
            344,
            345,
            346,
            347,
            348,
            349,
            350,
            351,
            354,
            355,
            360,
            361,
            362,
            364,
            366,
            367,
            368,
            369,
            370,
            371,
            372,
            373,
            374,
            375,
            376,
            377,
            380,
            381,
            382,
            383,
            384,
            385,
            386,
            387,
            388,
            389,
            390,
            391,
            392,
            393,
            394,
            395,
            396,
            397,
            398,
            400,
            401,
            402,
            405,
            406,
            407,
            408,
            409,
            410,
            411,
            412,
            413,
            415,
            416,
            418,
            419,
            420,
            421,
            422,
            423,
            424,
            425,
            426,
            427,
            430,
            431,
            432,
            433,
            434,
            435,
            436,
            437,
            438,
            439,
            440,
            441,
            442,
            443,
            445,
            446,
            450,
            451,
            452,
            454,
            455,
            456,
            457,
            458,
            459,
            460,
            461,
            474,
            475,
            476,
            477,
            478,
            479,
            480,
            481,
            482,
            483,
            485
        ]
    },
    {
        "id": "chapter6",
        "name": "Sa hình",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            486,
            487,
            488,
            489,
            490,
            491,
            492,
            493,
            494,
            495,
            496,
            497,
            498,
            499,
            500,
            501,
            502,
            503,
            504,
            505,
            506,
            507,
            508,
            509,
            510,
            511,
            512,
            513,
            514,
            515,
            516,
            517,
            518,
            519,
            520,
            521,
            522,
            523,
            524,
            525,
            526,
            527,
            528,
            529,
            530,
            531,
            532,
            533,
            534,
            535,
            536,
            537,
            538,
            539,
            540,
            541,
            542,
            543,
            544,
            545,
            546,
            547,
            548,
            549,
            550,
            551,
            552,
            553,
            554,
            555,
            556,
            557,
            558,
            559,
            560,
            561,
            562,
            563,
            564,
            565,
            566,
            567,
            568,
            569,
            570,
            571,
            572,
            573,
            574,
            575,
            576,
            577,
            578,
            579,
            580,
            581,
            582,
            583,
            584,
            585,
            586,
            587,
            588,
            589,
            590,
            591,
            592,
            593,
            594,
            595,
            596,
            597,
            598,
            599,
            600
        ]
    },
    {
        "id": "chapter6",
        "name": "Sa hình",
        "codes": [
            "A1_A"
        ],
        "questions": [
            486,
            487,
            490,
            492,
            495,
            499,
            500,
            503,
            504,
            505,
            507,
            508,
            509,
            517,
            520,
            525,
            527,
            528,
            529,
            538,
            539,
            540,
            543,
            548,
            553,
            556,
            559,
            560,
            562,
            565,
            567,
            568,
            583,
            592,
            600
        ]
    },
    {
        "id": "chapter6",
        "name": "Sa hình",
        "codes": [
            "B1"
        ],
        "questions": [
            486,
            487,
            490,
            492,
            495,
            499,
            500,
            503,
            504,
            505,
            507,
            508,
            509,
            517,
            520,
            525,
            527,
            528,
            529,
            538,
            539,
            540,
            543,
            548,
            553,
            556,
            559,
            560,
            562,
            565,
            567,
            568,
            583,
            592,
            600
        ]
    },
    {
        "id": "important",
        "name": "Quan trọng",
        "codes": [
            "B",
            "C1",
            "C",
            "D1_D2_D_BE_C1E_CE_D1E_D2E_DE"
        ],
        "questions": [
            19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 32, 34, 35, 47, 48, 52, 53, 55, 58, 63, 64, 65, 66, 67, 68, 70, 71, 72, 73, 74, 85, 86, 87, 88, 89, 90, 91, 92, 93, 97, 98, 102, 117, 163, 165, 167, 197, 198, 206, 215, 226, 234, 245, 246, 252, 253, 254, 255, 260
        ]
    },
    {
        "id": "important",
        "name": "Quan trọng",
        "codes": [
            "A1_A"
        ],
        "questions": [
            9, 20, 21, 22, 24, 26, 27, 28, 30, 47, 48, 52, 53, 63, 64, 65, 68, 70, 71, 72
        ]
    },
    {
        "id": "important",
        "name": "Quan trọng",
        "codes": [
            "B1"
        ],
        "questions": [
            19, 20, 21, 22, 24, 26, 27, 28, 30, 47, 48, 52, 53, 63, 64, 65, 68, 70, 71, 72, 73, 74, 87, 89, 90, 91, 92, 215, 254, 255
        ]
    }
]